/**
 * Single source of truth for the weXare brand identity.
 *
 * Every surface that shows the logo, the wordmark, or the marketing URL
 * imports from here. When the brand changes, this is the only file that
 * needs editing.
 */

/** Path to the SVG mark served from /public. Used as favicon and in-app logo. */
export const BRAND_LOGO_PATH = "/icon.svg";

/** The human-readable product name, used in UI wordmarks and PDF metadata. */
export const BRAND_NAME = "weXare";

/** Full site URL — the marketing domain. */
export const BRAND_URL = "https://wexare.com";

/** Bare hostname for display (email footers, PDF footers). */
export const BRAND_HOST = "wexare.com";

/** "Powered by weXare" line stamped on AI exports and image watermarks. */
export const BRAND_LINE = `Powered by ${BRAND_NAME}`;

/** Default OG image path (relative to the app origin). */
export const BRAND_OG_IMAGE_PATH = "/og-default.png";

/** Default page title for OG tags. */
export const BRAND_DEFAULT_TITLE = `${BRAND_NAME} \u2014 Get more done, together`;
